export default __webpack_public_path__ + "static/miro-5c5f0f4bc4a8bd525d5fee8e4b861758.svg";